// const $ = window.jQuery; // defined globally in Vite
import Headroom from "headroom.js";
import "slick-carousel";

$(() => {
	inviewAnimate();
	activateHeroYellowUnderlines();
	initHeadroom();
	headerMenu();
	initSubmenus();
	initNewsCarouselBanner();
	closeBanner();
	initGTM.init();
});

const initHeadroom = () => {
	const header = document.querySelector(".site-header");

	if (!header) {
		return;
	}

	const headroom = new Headroom(header);
	headroom.init();
};

const inviewSelectors = [
	".inview-animate--fade",
	".inview-animate--move-up",
	".inview-animate--move-down",
	".inview-animate--move-left",
	".inview-animate--move-right",
	".inview-animate--scale",
	".inview-animate--draw",
].join(", ");

const getUnderlineDelay = (element) => {
	const customDelay = parseFloat(element.getAttribute("data-underline-delay"));

	if (!Number.isNaN(customDelay)) {
		return customDelay;
	}

	if (element.classList.contains("inview-animate--move-up")) {
		return 1500;
	}

	if (element.classList.contains("inview-animate--fade")) {
		return 850;
	}

	return 0;
};

const scheduleYellowUnderline = (underline, delay) => {
	if (underline.dataset.underlineTimer) {
		window.clearTimeout(Number(underline.dataset.underlineTimer));
	}

	underline.classList.remove("inview-active");

	const activate = () => {
		underline.classList.add("inview-active");
		delete underline.dataset.underlineTimer;
	};

	if (delay > 0) {
		underline.dataset.underlineTimer = String(window.setTimeout(activate, delay));
		return;
	}

	void underline.offsetWidth;
	activate();
};

const activateYellowUnderlines = (element) => {
	const delay = getUnderlineDelay(element);

	element.querySelectorAll(".yellow-underline").forEach((underline) => {
		if (underline.closest(".hero-home, .hero-simple")) {
			return;
		}

		const animatedOwner = underline.closest(inviewSelectors);

		if (animatedOwner && animatedOwner !== element) {
			return;
		}

		scheduleYellowUnderline(underline, delay);
	});
};

const activateHeroYellowUnderlines = () => {
	document
		.querySelectorAll(".hero-simple .yellow-underline, .hero-home .yellow-underline")
		.forEach((underline) => {
			const delay = underline.closest(".hero-home") ? 850 : 1500;
			scheduleYellowUnderline(underline, delay);
		});
};

const inviewAnimate = () => {
	const elements = document.querySelectorAll(`
		.inview-animate--fade,
		.inview-animate--move-up,
		.inview-animate--move-down,
		.inview-animate--move-left,
		.inview-animate--move-right,
		.inview-animate--scale,
		.inview-animate--draw
	`);

	elements.forEach((element) => {
		if (element.classList.contains("yellow-underline")) {
			return;
		}

		if (element.closest(".resource-hero")) {
			element.classList.add("inview-active");
			activateYellowUnderlines(element);
			return;
		}

		const threshold =
			parseFloat(element.getAttribute("data-threshold")) || 0.05;

		const observer = new IntersectionObserver(
			(entries, currentObserver) => {
				entries.forEach((entry) => {
					if (
						entry.isIntersecting &&
						entry.intersectionRatio >= threshold
					) {
						entry.target.classList.add("inview-active");
						activateYellowUnderlines(entry.target);
						currentObserver.unobserve(entry.target);
					}
				});
			},
			{ threshold }
		);

		observer.observe(element);
	});
};

const headerMenu = () => {
	const $header = $(".site-header");
	const $nav = $(".site-header__nav");
	const $burger = $(".menu-hamburger");
	const $htmlBody = $("html, body");

	if (!$burger.length || !$nav.length) {
		return;
	}

	const closeMenu = () => {
		$burger.removeClass("active").attr("aria-expanded", "false");
		$nav.removeClass("active");
		$header.removeClass("menu-open");
		$htmlBody.removeClass("noscroll");
	};

	$burger.on("click", function () {
		const isOpen = !$(this).hasClass("active");

		$(this)
			.toggleClass("active", isOpen)
			.attr("aria-expanded", String(isOpen));

		$nav.toggleClass("active", isOpen);
		$header.toggleClass("menu-open", isOpen);
		$htmlBody.toggleClass("noscroll", isOpen);
	});

	$nav.on("click", 'a:not([href="#"])', function () {
		if (window.innerWidth < 992) {
			closeMenu();
		}
	});

	$(document).on("keydown", function (e) {
		if (e.key === "Escape") {
			closeMenu();
		}
	});

	$(window).on("resize", function () {
		if (window.innerWidth >= 992) {
			closeMenu();
		}
	});
};

const initSubmenus = () => {
	const $menuItems = $(".site-header .menu-item-has-children");

	if (!$menuItems.length) {
		return;
	}

	$menuItems.each(function () {
		const $item = $(this);
		const $submenu = $item.children(".sub-menu");

		if (!$submenu.length || $item.children(".submenu-toggle").length) {
			return;
		}

		const $toggle = $(`
			<button
				type="button"
				class="submenu-toggle"
				aria-expanded="false"
				aria-label="Toggle submenu"
			>
				<svg width="12" height="8" viewBox="0 0 12 8" fill="none" aria-hidden="true">
					<path
						d="M1 1.5L6 6.5L11 1.5"
						stroke="currentColor"
						stroke-width="1.67"
						stroke-linecap="round"
						stroke-linejoin="round"
					/>
				</svg>
			</button>
		`);

		$item.append($toggle);

		$toggle.on("click", function (e) {
			e.preventDefault();
			e.stopPropagation();

			if (window.innerWidth >= 992) {
				return;
			}

			const isOpen = $(this).attr("aria-expanded") === "true";

			$(this)
				.attr("aria-expanded", String(!isOpen))
				.toggleClass("submenu-active", !isOpen);

			$submenu.stop(true, true).slideToggle(250);
		});
	});

	const resetSubmenus = () => {
		if (window.innerWidth >= 992) {
			$(".site-header .sub-menu").removeAttr("style");
			$(".submenu-toggle")
				.removeClass("submenu-active")
				.attr("aria-expanded", "false");
		} else {
			$(".site-header .sub-menu").hide();
		}
	};

	resetSubmenus();

	$(window).on("resize", resetSubmenus);

	$(".top-menu-has-children > a").on("click", function (e) {
		if ($(this).attr("href") === "#") {
			e.preventDefault();
		}
	});
};

const closeBanner = () => {
	const $header = $(".site-header");
	const $banner = $(".banner");

	if (!$banner.length) {
		return;
	}

	if ($header.hasClass("banner-on")) {
		$("body").addClass("with-banner");
	}

	$(".close-banner").on("click", function () {
		$banner.slideUp(250, function () {
			$header.removeClass("banner-on");
			$("body").removeClass("with-banner");
		});
	});
};

const initNewsCarouselBanner = () => {
	const banners = document.querySelectorAll(".news-carousel-banner-items");

	if (!banners.length || typeof Swiper === "undefined") {
		return;
	}

	const syncHeight = (slider, swiper = null) => {
		const bannerInner = slider.closest(".news-carousel-banner-inner");
		const icon = bannerInner?.querySelector(".news-carousel-banner-icon");
		const bannerHeight = icon?.offsetHeight || bannerInner?.offsetHeight;

		if (!bannerHeight) {
			return;
		}

		slider.style.height = `${bannerHeight}px`;

		const wrapper = slider.querySelector(".swiper-wrapper");

		if (wrapper) {
			wrapper.style.height = `${bannerHeight}px`;
		}

		slider.querySelectorAll(".swiper-slide").forEach((slide) => {
			slide.style.height = `${bannerHeight}px`;
		});

		slider.querySelectorAll(".news-carousel-banner-item").forEach((item) => {
			item.style.height = "100%";
		});

		if (swiper) {
			swiper.update();
		}
	};

	banners.forEach((slider) => {
		if (slider.swiper) {
			return;
		}

		const swiper = new Swiper(slider, {
			direction: "vertical",
			slidesPerView: 1,
			slidesPerGroup: 1,
			loop: true,
			speed: 1100,
			allowTouchMove: false,

			autoplay: {
				delay: 3000,
				disableOnInteraction: false,
				pauseOnMouseEnter: false,
			},

			on: {
				init() {
					syncHeight(slider, this);
				},
				resize() {
					syncHeight(slider, this);
				},
				slideChangeTransitionEnd() {
					syncHeight(slider, this);
				},
			},
		});

		syncHeight(slider, swiper);
	});

	window.addEventListener("load", () => {
		banners.forEach((slider) => {
			syncHeight(slider, slider.swiper);
		});
	});
};

// GTM – lazy load optimized for Core Web Vitals
const initGTM = (() => {
	let gtmLoaded = false;

	const loadGTM = () => {
		if (gtmLoaded || !window.GTM_ID) {
			return;
		}

		gtmLoaded = true;

		window.dataLayer = window.dataLayer || [];
		window.dataLayer.push({
			"gtm.start": new Date().getTime(),
			event: "gtm.js",
		});

		const script = document.createElement("script");
		script.async = true;
		script.src =
			"https://www.googletagmanager.com/gtm.js?id=" +
			window.GTM_ID;

		document.head.appendChild(script);
	};

	const init = () => {
		if ("requestIdleCallback" in window) {
			requestIdleCallback(loadGTM, { timeout: 3000 });
		} else {
			setTimeout(loadGTM, 2000);
		}

		["scroll", "mousemove", "touchstart", "click"].forEach((event) => {
			window.addEventListener(event, loadGTM, {
				once: true,
				passive: true,
			});
		});
	};

	return { init };
})();
